import React from 'react';
import {connect} from 'react-redux';
import {requestDirectory} from '../../actions/directoryActions';
import {Container} from 'reactstrap';
import NodeList from './NodeList';

class Browse extends React.Component {
    componentDidMount() {
        if (!this.props.directory) {
            this.props.requestDirectory();
        }
    }

    render() {
        const {directory} = this.props;
        return (
            <Container>
                <h1>Browse directory</h1>
                {directory && <NodeList items={directory.nodes} />}
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    directory: state.directory.data,
});

export default connect(mapStateToProps, {requestDirectory})(Browse);
